// Hebammen-Tool runtime — auto-generated, do not edit.
// Regenerate with `node cli.js deploy` from ~/projects/actinovo-hebammen-tool/
"use strict";
// ─── data load ──────────────────────────────────────────────────────
let DATA = null;
async function loadData() { DATA = {
  "_meta": {
    "version": "1.0.0",
    "compiled": "2026-06-02",
    "scope": "Mikronährstoffbedarf Frau · Kinderwunsch → Stillzeit 12 Monate",
    "disclaimer": "Beratungsempfehlung auf Basis öffentlicher Leitlinien. Ersetzt keine individuelle ärztliche Diagnostik. Therapeutische Substitution bei Diagnose (z. B. Anämie) erfordert Laborkontrolle und ärztliche Verordnung."
  },
  "sources": [
    { "label": "DGE D-A-CH Referenzwerte 2024",                       "url": "https://www.dge.de/wissenschaft/referenzwerte/" },
    { "label": "DGE Handlungsempfehlungen Schwangerschaft (Gesund ins Leben)", "url": "https://www.dge.de/gesunde-ernaehrung/gezielte-ernaehrung/ernaehrung-in-schwangerschaft-und-stillzeit/handlungsempfehlungen-ernaehrung-in-der-schwangerschaft/" },
    { "label": "BfR – Jod, Folat/Folsäure und Schwangerschaft",       "url": "https://www.bfr.bund.de/cm/350/jod-folat-folsaeure-und-schwangerschaft.pdf" },
    { "label": "AWMF S1-LL 025/021 Eisenmangelanämie (2021)",         "url": "https://register.awmf.org/assets/guidelines/025-021l_S1_Eisenmangelanaemie_2021-11.pdf" },
    { "label": "OEGGG/AGG Empfehlungen Eisenmangelanämie SS",          "url": "https://oeggg.at/wp-content/uploads/2022/08/Eisenpaper-OEGGG-GebFrau.pdf" },
    { "label": "AWMF S3-LL Gestationsdiabetes 057-008",                "url": "https://register.awmf.org/de/leitlinien/detail/057-008" },
    { "label": "Verbraucherzentrale – NEM in SS/Stillzeit",             "url": "https://www.verbraucherzentrale.de/wissen/lebensmittel/nahrungsergaenzungsmittel/mehr-drin-als-noetig-nahrungsergaenzung-rund-um-schwangerschaft-und-stillzeit-11633" }
  ],
  "phases": {
    "kinderwunsch": {
      "label": "Kinderwunsch",
      "nutrients": {
        "folat":      { "amount": "400 µg Folsäure/Tag (≥4 Wo. präkonzeptionell)", "level": "hoch",    "reason": "Neuralrohrdefekt-Prophylaxe; bei späterem Beginn 800 µg/Tag (BfR)",        "food_sources": ["Blattgemüse", "Hülsenfrüchte", "Vollkorn"],                  "upper_limit": "UL EFSA 1000 µg synth. Folsäure/Tag" },
        "eisen":      { "amount": "16 mg/Tag (DGE)",                                 "level": "moderat", "reason": "Speicheraufbau vor Konzeption senkt Anämierisiko in T2/T3",                  "food_sources": ["Hülsenfrüchte", "Vollkorn", "rotes Fleisch", "Haferflocken"], "upper_limit": "BfR NEM 6 mg/Tag; Substitution nur nach Labor" },
        "jod":        { "amount": "200 µg/Tag (DGE)",                                "level": "hoch",    "reason": "SD-Speicheraufbau für frühe Embryogenese; DE = mildes Jodmangelgebiet",       "food_sources": ["jodiertes Salz", "Seefisch", "Milchprodukte"],               "upper_limit": "BfR NEM 100 µg/Tag (Schwangere 150 µg)" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",                       "level": "moderat", "reason": "25-OH-D > 50 nmol/l vor Konzeption — Bezug zu Fertilität und Implantation",  "food_sources": ["fetter Seefisch", "Eigelb", "Sonnenlicht"],                   "upper_limit": "BfR NEM 20 µg/Tag; UL EFSA 100 µg/Tag" },
        "b12":        { "amount": "4,0 µg/Tag (DGE 2019)",                          "level": "moderat", "reason": "Speicher auffüllen — kritisch bei veg./veganer Kost",                       "food_sources": ["Fleisch", "Fisch", "Eier", "Milchprodukte"],                  "upper_limit": "Kein UL definiert" },
        "b_komplex":  { "amount": "B6 1,4 mg/Tag (DGE)",                            "level": "moderat", "reason": "B6 + Folat + B12 = Homocystein-Stoffwechsel, Zellteilung",                   "food_sources": ["Vollkorn", "Bananen", "Nüsse", "Geflügel"],                   "upper_limit": "B6 UL EFSA 12 mg/Tag; BfR NEM 3,5 mg/Tag" },
        "magnesium":  { "amount": "300–350 mg/Tag (DGE)",                           "level": "niedrig", "reason": "Basisbedarf; keine spezifische Kinderwunsch-Erhöhung evident",               "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte", "grünes Gemüse"],         "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag (DGE)",                          "level": "moderat", "reason": "Speicheraufbau für frühe ZNS-/Retina-Entwicklung",                           "food_sources": ["fetter Seefisch (Lachs, Makrele, Hering)", "Algenöl (vegan)"], "upper_limit": "EFSA: bis 5 g EPA+DHA/Tag" }
      }
    },
    "schwanger_t1": {
      "label": "Schwangerschaft · 1. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag — Supplement 400 µg bis SSW 12 (BfR)", "level": "hoch",    "reason": "Neuralrohrschluss bis Tag 28 p.c. — obligate Supplementierung",          "food_sources": ["Blattgemüse", "Hülsenfrüchte", "angereicherte Lebensmittel"], "upper_limit": "UL EFSA 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag (DGE)",                                                "level": "hoch",    "reason": "Plasmavolumen-Expansion + fetaler Bedarf — ca. +100 % vs. nicht-SS",       "food_sources": ["rotes Fleisch", "Hülsenfrüchte", "Hafer + Vit-C-Kost"],         "upper_limit": "Substitution nur nach Labor" },
        "jod":        { "amount": "230 µg/Tag (DGE) — 100–150 µg davon als Supplement (BfR)",        "level": "hoch",    "reason": "Maternale T4 + fetale SD-Entwicklung",                                     "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                          "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",                                       "level": "moderat", "reason": "Plazentafunktion + Präeklampsie-Modulation",                              "food_sources": ["Seefisch", "Eigelb", "Sonnenlicht"],                            "upper_limit": "BfR NEM 20 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag (DGE)",                                               "level": "moderat", "reason": "Zellteilung, Erythropoese, Plazentatransfer",                              "food_sources": ["tierische Lebensmittel"],                                       "upper_limit": "Kein UL" },
        "b_komplex":  { "amount": "B6 1,5 mg/Tag",                                                  "level": "moderat", "reason": "B6 reduziert SS-Übelkeit (Cochrane); Homocysteinsenkung",                 "food_sources": ["Vollkorn", "Banane", "Kartoffel", "Geflügel"],                  "upper_limit": "UL EFSA 12 mg/Tag" },
        "magnesium":  { "amount": "310 mg < 25 J, 350 mg ≥ 25 J / Tag (DGE)",                       "level": "moderat", "reason": "Wadenkrämpfe, Uterus-Tonus — kein pauschales NEM laut DGE",               "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte"],                            "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                "level": "moderat", "reason": "Beginn fetale Neurogenese — Reduktion Frühgeburtsrisiko (Cochrane 2018)",  "food_sources": ["Seefisch 1–2×/Wo.", "Algenöl"],                                  "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "schwanger_t2": {
      "label": "Schwangerschaft · 2. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Nach Neuralrohrschluss reicht ernährungsbasierte Zufuhr; NEM nur bei Risiken", "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag — Mehrbedarf fetal ca. +5 mg/Tag (AGG/OEGGG)",          "level": "hoch",    "reason": "Wachsendes Blutvolumen — erste Anämie-Manifestation ab ~SSW 20",            "food_sources": ["rotes Fleisch", "Hülsenfrüchte", "Vit-C-Kombi"],                  "upper_limit": "Substitution nach Ferritin/Hb (S1-LL 025/021)" },
        "jod":        { "amount": "230 µg/Tag",                                                      "level": "hoch",    "reason": "Anhaltend erhöhter Bedarf für fetale SD",                                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Fortgesetzte Knochenmineralisation des Feten",                             "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag",                                                      "level": "moderat", "reason": "Erythropoese; fetale Myelinisierung beginnt",                              "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,8 mg/Tag (DGE T2/T3)",                                       "level": "moderat", "reason": "Eiweißstoffwechsel-Bedarf steigt",                                          "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "310–350 mg/Tag",                                                  "level": "moderat", "reason": "Häufig zur Tokolyse-Adjuvanz und gegen Wadenkrämpfe",                      "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Hauptphase fetale ZNS-Entwicklung",                                        "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "schwanger_t3": {
      "label": "Schwangerschaft · 3. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Erhaltungsbedarf",                                                          "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag (DGE); klinisch oral 20–30 mg/Tag in letzten 2 Mon.",   "level": "hoch",    "reason": "Höchster fetaler Eisen-Transfer + Vorbereitung Geburtsblutverlust",         "food_sources": ["rotes Fleisch", "Linsen", "Haferflocken"],                        "upper_limit": "Therapeutisch nach Labor 30–80 mg/Tag (S1-LL)" },
        "jod":        { "amount": "230 µg/Tag",                                                      "level": "hoch",    "reason": "Bedarf bleibt erhöht",                                                      "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Spitze fetaler Calcium-/Knochenaufbau im T3",                                "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag",                                                      "level": "moderat", "reason": "Speicheranlage für Säugling über Stillzeit",                                "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,8 mg/Tag",                                                   "level": "moderat", "reason": "Erhöhter Eiweißstoffwechsel kurz vor Geburt",                               "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "310–350 mg/Tag",                                                  "level": "moderat", "reason": "Wehenmodulation, Krampfprophylaxe",                                          "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Maximaler DHA-Transfer 2. Lebenshälfte des Feten; Frühgeburtsrisiko sinkt",  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "wochenbett": {
      "label": "Wochenbett",
      "note": "DGE hat keinen separaten Wochenbett-Wert. Bei Stillenden Werte = Stillzeit; bei Nicht-Stillenden Erwachsenenwert + Regenerationsbedarf nach Geburtsblutverlust.",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Erythropoese-Regeneration nach Geburt",                                      "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                                                       "level": "hoch",    "reason": "Blutverlust sub partu 300–500 ml (vaginal) bis 1000 ml (Sectio)",            "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],                                "upper_limit": "Bei Hb < 100 g/l: oral 80–200 mg/Tag (S1-LL)" },
        "jod":        { "amount": "200 µg/Tag (DGE-Update 2024)",                                    "level": "hoch",    "reason": "Säugling deckt SD-Bedarf vollständig über Muttermilch",                     "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Knochen-Recovery, Stimmungsmodulation, geringer Übertrag in Muttermilch",     "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag (Stillzeit)",                                          "level": "moderat", "reason": "B12-Übertrag in Muttermilch",                                                "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                                                   "level": "moderat", "reason": "Erholung Eiweißstoffwechsel + Stillbedarf",                                "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "390 mg/Tag (DGE Stillzeit)",                                      "level": "moderat", "reason": "Mg-Verlust über Muttermilch + Krampfneigung erste Wochen",                  "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Auffüllen mütterlicher Speicher + Übergang in Muttermilch",                  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "stillzeit_1_6m": {
      "label": "Stillzeit · Monat 1–6",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Übertritt in Muttermilch",                                                  "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                                                       "level": "moderat", "reason": "Kompensation SS-/Geburtsverlust; Muttermilch ist eisenarm",                  "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],                                "upper_limit": "Substitution nur bei Diagnose" },
        "jod":        { "amount": "200 µg/Tag",                                                      "level": "hoch",    "reason": "Säugling deckt SD-Bedarf über Muttermilch",                                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag — Vorsicht Hypothyreose-Risiko bei Überdosis" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Muttermilch transportiert wenig Vit D; Säugling erhält eigene Prophylaxe",     "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "BfR NEM 20 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag",                                                      "level": "hoch",    "reason": "Direkter Übertritt — B12-Mangel der Mutter führt rasch zu Säuglingsschäden",  "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                                                   "level": "moderat", "reason": "Übertritt in Muttermilch; sehr hohe B6-Dosen können Milchbildung hemmen",     "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag — > 200 mg dauerhaft: Neuropathierisiko" },
        "magnesium":  { "amount": "390 mg/Tag",                                                      "level": "moderat", "reason": "Höchster Mg-Bedarf aller Lebensphasen — Milchbildung",                       "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "ZNS-Entwicklung Säugling in ersten 6 Mo. sensibel für DHA",                  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "stillzeit_6_12m": {
      "label": "Stillzeit · Monat 6–12",
      "note": "DGE differenziert 1–6 vs. 6–12 nicht; Werte identisch. In der Praxis Bedarf parallel zur abnehmenden Stillmenge ↘ ab Beikost-Start.",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",         "level": "moderat", "reason": "Anhaltend leicht erhöht",                                "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                       "level": "moderat", "reason": "Speicher-Erhaltung; Menses kehrt meist zurück",          "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],              "upper_limit": "nur bei Diagnose" },
        "jod":        { "amount": "200 µg/Tag",                      "level": "hoch",    "reason": "Bei relevanter Stillmenge gleich hoch",                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],         "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",              "level": "moderat", "reason": "Identische Empfehlung",                                   "food_sources": ["Seefisch", "Sonnenlicht"],                      "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag",                      "level": "hoch",    "reason": "Solange gestillt wird, gleicher Bedarf",                 "food_sources": ["tierische LM"],                                 "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                   "level": "moderat", "reason": "Identisch",                                              "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "390 mg/Tag",                      "level": "moderat", "reason": "Bei Teilstillen Bedarf ↘",                              "food_sources": ["Vollkorn", "Nüsse"],                            "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                 "level": "moderat", "reason": "DHA in Muttermilch korreliert mit mütterlicher Zufuhr",   "food_sources": ["Seefisch", "Algenöl"],                          "upper_limit": "EFSA 5 g/Tag" }
      }
    }
  },
  "modifiers": {
    "mehrlinge": {
      "label": "Mehrlinge",
      "note": "Keine DACH-Mehrlings-Referenzwerte. Faustregel (Springer 2025 / AGG): +25–50 % Mikronährstoffbedarf je weiterem Feten; engmaschige Labor-Kontrollen.",
      "adjust": {
        "folat":      "+200–400 µg Folsäure/Tag (gesamt 600–800 µg bis Ende T1)",
        "eisen":      "30–60 mg/Tag oral ab T2 nach Labor (OEGGG)",
        "jod":        "+50 µg/Tag (gesamt 250–300 µg)",
        "vitamin_d":  "individuell nach Spiegel, oft 1000–2000 IE/Tag",
        "magnesium":  "+50 mg/Tag",
        "omega3_dha": "300–400 mg DHA/Tag (Frühgeburtsrisiko ↑)"
      }
    },
    "vegan": {
      "label": "Vegan",
      "note": "Vegane Kost in SS/Stillzeit ist möglich, braucht aber gezielte Substitution und engmaschiges Labor-Monitoring (Ferritin, B12, 25-OH-D). Begleite mit klarem Substitutionsplan und kontrolliere die Werte regelmäßig.",
      "adjust": {
        "b12":        "obligat substituieren — 25–100 µg/Tag oral (Hochdosis wegen niedriger Absorption)",
        "jod":        "150 µg/Tag NEM zusätzlich zu jodiertem Salz",
        "eisen":      "Labor-basiert, häufig 30 mg/Tag + Vit-C-Kombi",
        "omega3_dha": "200–300 mg DHA/Tag aus Algenöl (ALA→DHA-Konversion < 5 %)",
        "vitamin_d":  "20 µg/Tag — vegane D3-Quelle (Flechten) oder D2",
        "b_komplex":  "B2 (Riboflavin) prüfen — bei Veganerinnen häufig grenzwertig"
      }
    },
    "vegetarisch": {
      "label": "Vegetarisch",
      "note": "Lakto-ovo-vegetarisch: meist nur Eisen und ggf. Omega-3 kritisch.",
      "adjust": {
        "eisen":      "Ferritin-Kontrolle, niedrigschwellig 30 mg/Tag",
        "omega3_dha": "200 mg DHA/Tag (Algenöl) bei Fischverzicht",
        "b12":        "Labor-Kontrolle, ggf. 10–25 µg/Tag",
        "jod":        "100–150 µg/Tag NEM falls kein Seefisch"
      }
    },
    "eisenmangel_dx": {
      "label": "Eisenmangel diagnostiziert",
      "note": "Therapie nach AWMF S1-LL 025/021 + OEGGG. Gabe alle 2 Tage zeigt bessere Resorption (Stoffel 2017) als tägliche Hochdosis.",
      "adjust": {
        "eisen":      "Leicht (Ferritin < 30 µg/l, Hb > 100): 30–80 mg/Tag oral alle 2 Tage · Mittel/schwer (Hb < 95 g/l) oder T3/Unverträglichkeit: i.v. Eisencarboxymaltose 1000–1500 mg · Ziel Hb > 110 g/l, Ferritin > 30 µg/l",
        "vitamin_c":  "200 mg Vit C zu jeder Eisen-Einnahme (Resorption × 2–3)"
      }
    },
    "gdm": {
      "label": "Gestationsdiabetes",
      "note": "S3-LL GDM 057-008: Ernährungstherapie an erster Stelle. Mikronährstoff-Defizite (Vit D, Mg, B12 bei Metformin) gezielt kontrollieren.",
      "adjust": {
        "vitamin_d":  "Spiegel-orientiert, oft 1000–2000 IE/Tag (HbA1c, Insulinresistenz ↓)",
        "magnesium":  "300 mg/Tag NEM bei Mg-Mangel — niedriger Mg-Status = späteres T2DM-Risiko",
        "b12":        "Bei Metformin: 1000 µg/Tag oral oder Labor alle 6 Mo. (Metformin senkt B12-Resorption)",
        "folat":      "Bei Metformin Folat-Spiegel überwachen",
        "omega3_dha": "200–300 mg DHA/Tag (antiinflammatorisch)"
      }
    },
    "sectio": {
      "label": "Z. n. Sectio",
      "note": "Mittlere Bauch-OP. Mehrbedarf für Proteine, Zink, Vit C, B-Vitamine in den ersten 4–6 Wochen. Blutverlust meist 700–1000 ml.",
      "adjust": {
        "eisen":      "Hb-Kontrolle Tag 2–3 · Hb < 95 g/l → i.v. Eisencarboxymaltose 500–1000 mg · Hb 95–105 g/l → oral 80–160 mg/Tag",
        "b_komplex":  "B1/B6/B12 für 4–6 Wo. ergänzen — Wundheilung, Energie",
        "magnesium":  "300–400 mg/Tag — Krampfprophylaxe + Muskelregeneration Bauchdecke",
        "vitamin_c":  "200 mg/Tag bis Narbenheilung abgeschlossen — Kollagensynthese-Cofaktor",
        "zink":       "10 mg/Tag — Wundheilung + Immunfunktion"
      }
    },
    "bariatrie": {
      "label": "Z. n. bariatrische OP",
      "note": "Risikoschwangerschaft (SGA, IUGR ↑). Karenz ≥ 12–24 Mo. nach OP. Lebenslange Substitution, in SS/Stillzeit intensiviert. Quartalsweise Labor: Ferritin, B12, Folat, 25-OH-D, Ca, Zn, Cu, A/E/K.",
      "adjust": {
        "b12":        "1000 µg/Tag oral oder 1000 µg i.m. alle 1–3 Mo. — fehlender Intrinsic Factor",
        "eisen":      "45–60 mg/Tag (SS: 50–100 mg/Tag) — Sulfat/Fumarat/Gluconat",
        "folat":      "800–1000 µg/Tag — reduzierte Resorption proximaler Dünndarm",
        "vitamin_d":  "2000–4000 IE/Tag, Spiegel-gesteuert",
        "calcium":    "1200–1500 mg/Tag (Citrat bevorzugt)",
        "vitamin_a":  "VORSICHT — max. 2500–5000 IE/Tag als Retinol (höhere Dosen teratogen)",
        "thiamin_b1": "12–50 mg/Tag — Wernicke-Prophylaxe bei Hyperemesis",
        "omega3_dha": "200–300 mg DHA/Tag"
      }
    }
  },
  "actinovo_map": {
    "eisen":      { "name": "Liposomales Eisen",       "url": "https://actinovo.com/products/liposomales-eisen-kirsche-new-generation", "price": "20,90 €" },
    "b_komplex":  { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "b12":        { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "thiamin_b1": { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "vitamin_d":  { "name": "Liposomales D3/K2",       "url": "https://actinovo.com/products/liposomales-vitamin-d3-k2",                 "price": "23,90 €" },
    "magnesium":  { "name": "Liposomales Magnesium",   "url": "https://actinovo.com/products/liposomales-magnesium-basilikum-zitrone-holunder", "price": "25,90 €" },
    "omega3_dha": { "name": "Liposomales Omega-3 DHA", "url": "https://actinovo.com/products/omega-3-orange-liposomal-flavoured",         "price": "36,90 €" },
    "vitamin_c":  { "name": "Liposomales Vitamin C + Zink", "url": "https://actinovo.com/products/liposomales-vitamin-c-zink",            "price": null }
  },
  "nutrient_labels": {
    "folat":      "Folat / Folsäure",
    "eisen":      "Eisen",
    "jod":        "Jod",
    "vitamin_d":  "Vitamin D3/K2",
    "b12":        "Vitamin B12",
    "b_komplex":  "B-Komplex (B6)",
    "magnesium":  "Magnesium",
    "omega3_dha": "Omega-3 DHA",
    "vitamin_c":  "Vitamin C",
    "zink":       "Zink",
    "calcium":    "Calcium",
    "vitamin_a":  "Vitamin A",
    "thiamin_b1": "Thiamin (B1)"
  }
}; }

// ─── state ─────────────────────────────────────────────────────────
const state = {
  phase: null,
  modifiers: new Set(),
  hebName: '',
  hebStadt: '',
  klientin: '',
  kommentar: '',
  logoDataUrl: null
};

// ─── helpers ───────────────────────────────────────────────────────
function slugify(s) {
  return String(s || '').toLowerCase()
    .replace(/[äàá]/g, 'a').replace(/[öòó]/g, 'o').replace(/[üùú]/g, 'u').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 50);
}
function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
// Synchronously render QR onto a canvas using qrcode-generator
// (Kazuhiko Arase) — has no browser-bundle issues, returns PNG
// that pdf-lib.embedPng can ingest.
function makeQrDataUrl(url, size) {
  if (typeof qrcode !== 'function') {
    throw new Error('QR-Code-Library nicht geladen');
  }
  const qr = qrcode(0, 'M');  // typeNumber=0 → auto-size
  qr.addData(url);
  qr.make();
  const count = qr.getModuleCount();
  const cell = Math.max(1, Math.floor(size / count));
  const real = cell * count;
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = real;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, real, real);
  ctx.fillStyle = '#003087';
  for (let r = 0; r < count; r++) {
    for (let c = 0; c < count; c++) {
      if (qr.isDark(r, c)) ctx.fillRect(c*cell, r*cell, cell, cell);
    }
  }
  return canvas.toDataURL('image/png');
}

const DISCOUNT_CODE = 'Hebamme15';
const DISCOUNT_BASE = 'https://actinovo.com/discount/' + DISCOUNT_CODE
  + '?redirect=%2Fcollections%2Falle-produkte-ohne-bundles';

function buildTrackedUrl() {
  const params = new URLSearchParams({
    utm_source: 'hebamme-pdf',
    utm_medium: 'qr',
    utm_campaign: 'hebammen-beratung-2026',
    utm_content: state.phase || 'unknown'
  });
  const hebSlug = slugify((state.hebName || '') + (state.hebStadt ? '-' + state.hebStadt : ''));
  if (hebSlug) params.set('hebamme', hebSlug);
  return DISCOUNT_BASE + '&' + params.toString();
}
function phaseLabel() {
  if (!state.phase || !DATA) return '— Wähle eine Phase —';
  return (DATA.phases[state.phase] || {}).label || '—';
}
function effectiveNutrients() {
  if (!state.phase || !DATA) return [];
  const phaseObj = DATA.phases[state.phase];
  if (!phaseObj) return [];
  return Object.entries(phaseObj.nutrients).map(([key, val]) => ({ key, ...val }));
}
function activeModifiers() {
  if (!DATA) return [];
  return Array.from(state.modifiers).map(k => DATA.modifiers[k]).filter(Boolean);
}
function metaParts() {
  const who = state.hebName
    ? (state.hebName + (state.hebStadt ? ', ' + state.hebStadt : ''))
    : '';
  const to = state.klientin || '';
  const when = new Date().toLocaleDateString('de-DE');
  return { who, to, when };
}

// ─── render preview ────────────────────────────────────────────────
function renderPhasePills() {
  const grid = document.getElementById('phaseGrid');
  grid.innerHTML = '';
  for (const [key, ph] of Object.entries(DATA.phases)) {
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'phase-pill' + (state.phase === key ? ' active' : '');
    pill.dataset.phase = key;
    const parts = ph.label.split('·');
    pill.innerHTML = parts[0].trim() +
      (parts.length > 1 ? '<small>' + parts.slice(1).join('·').trim() + '</small>' : '');
    pill.onclick = () => { state.phase = key; renderPhasePills(); renderPreview(); };
    grid.appendChild(pill);
  }
}

function renderModifierChips() {
  const wrap = document.getElementById('modifierChips');
  wrap.innerHTML = '';
  for (const [key, m] of Object.entries(DATA.modifiers)) {
    const chip = document.createElement('label');
    chip.className = 'chip' + (state.modifiers.has(key) ? ' active' : '');
    chip.innerHTML = '<input type="checkbox" data-mod="' + key + '"' +
      (state.modifiers.has(key) ? ' checked' : '') + '> ' + escapeHtml(m.label);
    chip.querySelector('input').onchange = (e) => {
      if (e.target.checked) state.modifiers.add(key); else state.modifiers.delete(key);
      chip.classList.toggle('active', e.target.checked);
      renderPreview();
    };
    wrap.appendChild(chip);
  }
}

async function renderPreview() {
  const { who, to, when } = metaParts();
  const hasPhase = !!state.phase;

  // logo
  document.getElementById('pvLogoSlot').innerHTML =
    state.logoDataUrl ? '<img src="' + state.logoDataUrl + '" alt="Logo">' : '';

  // title block
  document.getElementById('pvPhase').textContent = phaseLabel();
  document.getElementById('pvSubline').style.display = 'none';

  // personal block
  const personal = document.getElementById('pvPersonal');
  if (who || to) {
    personal.style.display = '';
    document.getElementById('pvFrom').textContent = who || '—';
    document.getElementById('pvTo').textContent = to || '—';
    document.getElementById('pvDate').textContent = when;
  } else {
    personal.style.display = 'none';
  }

  // nutrients
  const list = document.getElementById('pvNutrients');
  const nutrients = effectiveNutrients();
  const labels = DATA.nutrient_labels || {};

  if (!hasPhase || !nutrients.length) {
    list.innerHTML = '<div style="color:var(--ink-soft);font-size:13px;">Wähle Phase und Besonderheiten links, um die Empfehlung zu sehen.</div>';
    document.getElementById('pvModifiers').innerHTML = '';
    document.getElementById('pvComment').style.display = 'none';
    document.getElementById('pvActinovo').style.display = 'none';
    document.getElementById('pvSources').innerHTML = '';
    document.getElementById('pvMeta').textContent = 'Erstellt mit dem ActiNovo Hebammen-Tool';
    document.getElementById('downloadPdfBtn').disabled = true;
    document.getElementById('downloadHtmlBtn').disabled = true;
    return;
  }

  // optional phase note (e.g. Wochenbett DGE note)
  let listHtml = '';
  const phNote = DATA.phases[state.phase].note;
  if (phNote) {
    listHtml += `<div style="font-size:11px;color:var(--ink-soft);background:#F2F4F8;padding:8px 10px;border-radius:6px;margin-bottom:8px;">i ${escapeHtml(phNote)}</div>`;
  }

  for (const n of nutrients) {
    const lvl = n.level === 'hoch' ? 3 : n.level === 'moderat' ? 2 : 1;
    const bars = Array.from({length: 3}, (_, i) =>
      '<span class="' + (i < lvl ? 'on' : '') + '"></span>').join('');
    const niceName = labels[n.key] || n.key;
    const ulHint = n.upper_limit
      ? `<div class="upper-hint">! Obergrenze: ${escapeHtml(n.upper_limit)}</div>` : '';
    listHtml += `
      <div class="nutrient-row">
        <div class="nrow-main">
          <div class="nutrient-name">${escapeHtml(niceName)}</div>
          <div class="nutrient-amount">${escapeHtml(n.amount)}</div>
          <div class="nutrient-reason">${escapeHtml(n.reason)}<br>
            <span style="font-size:11px;">Quellen: ${escapeHtml(n.food_sources.join(', '))}</span>
          </div>
          ${ulHint}
        </div>
        <span class="level-bar">${bars}</span>
      </div>`;
  }
  list.innerHTML = listHtml;

  // modifiers
  const mods = activeModifiers();
  document.getElementById('pvModifiers').innerHTML = mods.map(m => {
    const adjustLines = m.adjust
      ? Object.entries(m.adjust).map(([k, v]) =>
          `<div class="mod-adjust"><strong>${escapeHtml(labels[k] || k)}:</strong> ${escapeHtml(v)}</div>`).join('')
      : '';
    return `<div class="modifier-note">
      <strong>${escapeHtml(m.label)}.</strong> ${escapeHtml(m.note || '')}
      ${adjustLines}
    </div>`;
  }).join('');

  // comment — only shown if non-empty
  const c = (state.kommentar || '').trim();
  const cBox = document.getElementById('pvComment');
  if (c) {
    cBox.style.display = '';
    document.getElementById('pvCommentText').textContent = c;
  } else {
    cBox.style.display = 'none';
  }

  // ActiNovo block + QR
  document.getElementById('pvActinovo').style.display = '';
  try {
    const qrDataUrl = await makeQrDataUrl(buildTrackedUrl(), 200);
    document.getElementById('pvQr').innerHTML = '<img src="' + qrDataUrl + '" alt="QR Code">';
  } catch(e) {
    console.warn('QR live:', e);
    document.getElementById('pvQr').innerHTML = '<div style="font-size:9px;color:var(--warn);text-align:center;padding:4px;">QR-Fehler: ' + escapeHtml(e.message) + '</div>';
  }

  // sources + meta
  document.getElementById('pvSources').innerHTML =
    'Quellen: ' + DATA.sources.map(s => escapeHtml(s.label)).join(' · ');
  const klientLine = to ? ' · für ' + to : '';
  document.getElementById('pvMeta').textContent =
    (who || 'Erstellt mit dem ActiNovo Hebammen-Tool') + klientLine + ' · ' + when;

  document.getElementById('downloadPdfBtn').disabled = false;
  document.getElementById('downloadHtmlBtn').disabled = false;
}

// ─── PDF generation ────────────────────────────────────────────────
function winAnsi(s) {
  return String(s == null ? '' : s)
    .replace(/⚠/g, '!').replace(/ℹ/g, 'i')
    .replace(/≥/g, '>=').replace(/≤/g, '<=')
    .replace(/→/g, '->').replace(/←/g, '<-')
    .replace(/↑/g, '(steigt)').replace(/↗/g, '(steigt)')
    .replace(/↓/g, '(sinkt)').replace(/↘/g, '(sinkt)')
    .replace(/×/g, 'x').replace(/…/g, '...');
}

async function buildPdf() {
  const { PDFDocument, StandardFonts, rgb, PDFName, PDFString } = PDFLib;
  const doc = await PDFDocument.create();
  const helv = await doc.embedFont(StandardFonts.Helvetica);
  const helvBold = await doc.embedFont(StandardFonts.HelveticaBold);
  const helvOblique = await doc.embedFont(StandardFonts.HelveticaOblique);

  const BRAND      = rgb(0/255, 48/255, 135/255);
  const BRAND_SOFT = rgb(0/255, 90/255, 185/255);
  const TINT       = rgb(238/255, 243/255, 251/255);
  const INK        = rgb(26/255, 26/255, 26/255);
  const INK_SOFT   = rgb(90/255, 97/255, 115/255);
  const LINE       = rgb(227/255, 231/255, 238/255);
  const WARN       = rgb(0.79, 0.47, 0.09);

  const M = 50, W = 595.28, H = 841.89;
  const TOP = H - M;
  const BOTTOM_LIMIT = M + 24;  // page bar area below this
  const contentW = W - 2*M;

  // ─── multi-page state ──────────────────────────────────
  const pages = [];
  let page = doc.addPage([W, H]);
  pages.push(page);
  let y = TOP;

  function newPage() {
    page = doc.addPage([W, H]);
    pages.push(page);
    // small continuation header so the reader knows where they are
    page.drawText(winAnsi('PERSÖNLICHE NÄHRSTOFF-BERATUNG · ' + phaseLabel()), {
      x: M, y: TOP - 8, size: 8, font: helvBold, color: BRAND
    });
    page.drawLine({
      start: { x: M, y: TOP - 16 }, end: { x: W - M, y: TOP - 16 },
      color: LINE, thickness: 0.4
    });
    y = TOP - 30;
  }

  function ensureSpace(needed) {
    if (y - needed < BOTTOM_LIMIT) newPage();
  }

  function addLinkAnnot(x, yPos, w, h, url, targetPage) {
    const t = targetPage || page;
    const annot = doc.context.obj({
      Type: 'Annot', Subtype: 'Link',
      Rect: [x, yPos, x + w, yPos + h],
      Border: [0, 0, 0],
      A: { Type: 'Action', S: 'URI', URI: PDFString.of(url) }
    });
    const ref = doc.context.register(annot);
    let annots = t.node.lookup(PDFName.of('Annots'));
    if (!annots) {
      annots = doc.context.obj([]);
      t.node.set(PDFName.of('Annots'), annots);
    }
    annots.push(ref);
  }

  const wrap = (text, font, size, maxWidth) => {
    const words = winAnsi(text).split(/\s+/);
    const lines = []; let line = '';
    for (const w of words) {
      const t = line ? line + ' ' + w : w;
      if (font.widthOfTextAtSize(t, size) <= maxWidth) line = t;
      else { if (line) lines.push(line); line = w; }
    }
    if (line) lines.push(line);
    return lines;
  };

  // ─── HEADER (first page only) ──────────────────────────
  page.drawRectangle({ x: M, y: y - 50, width: 3, height: 50, color: BRAND });
  page.drawText('PERSÖNLICHE NÄHRSTOFF-BERATUNG', {
    x: M + 14, y: y - 11, size: 9, font: helvBold, color: BRAND
  });
  page.drawText(winAnsi(phaseLabel()), {
    x: M + 14, y: y - 30, size: 17, font: helvBold, color: INK
  });

  if (state.logoDataUrl) {
    try {
      const isPng = state.logoDataUrl.startsWith('data:image/png');
      const bytes = await fetch(state.logoDataUrl).then(r => r.arrayBuffer());
      const img = isPng ? await doc.embedPng(bytes) : await doc.embedJpg(bytes);
      const maxH = 36;
      const scale = maxH / img.height;
      const lw = img.width * scale;
      page.drawImage(img, { x: W - M - lw, y: y - 38, width: lw, height: maxH });
    } catch(e) { console.warn('Logo embed failed:', e); }
  }
  y -= 70;

  // ─── personal box ──────────────────────────────────────
  const { who, to, when } = metaParts();
  if (who || to) {
    const boxH = 40;
    page.drawRectangle({ x: M, y: y - boxH, width: contentW, height: boxH, color: TINT });
    page.drawText('VON', { x: M + 12, y: y - 14, size: 7, font: helvBold, color: BRAND });
    page.drawText(winAnsi(who || '—'), { x: M + 50, y: y - 14, size: 10, font: helv, color: INK });
    page.drawText('FÜR', { x: M + 12, y: y - 30, size: 7, font: helvBold, color: BRAND });
    page.drawText(winAnsi(to || '—'), { x: M + 50, y: y - 30, size: 10, font: helv, color: INK });
    const dateW = helv.widthOfTextAtSize(when, 9);
    page.drawText(when, { x: W - M - 12 - dateW, y: y - 14, size: 9, font: helv, color: INK_SOFT });
    y -= boxH + 16;
  }

  // ─── section head + legend ─────────────────────────────
  ensureSpace(22);
  page.drawText('Erhöhter Bedarf jetzt', { x: M, y, size: 11, font: helvBold, color: BRAND });
  const drawLegendItem = (xStart, label, lvl) => {
    for (let i = 0; i < 3; i++) {
      page.drawRectangle({
        x: xStart + i*4.5, y: y + 1, width: 3, height: 6,
        color: i < lvl ? BRAND : LINE
      });
    }
    page.drawText(label, { x: xStart + 17, y, size: 7, font: helv, color: INK_SOFT });
  };
  const lgX = W - M - 165;
  drawLegendItem(lgX,        'niedrig', 1);
  drawLegendItem(lgX + 55,   'moderat', 2);
  drawLegendItem(lgX + 110,  'hoch',    3);
  y -= 18;

  // ─── nutrients ─────────────────────────────────────────
  const labels = DATA.nutrient_labels || {};
  for (const n of effectiveNutrients()) {
    const reasonLines = wrap(n.reason, helv, 9, contentW - 8);
    const ulLines = n.upper_limit
      ? wrap('! Obergrenze: ' + n.upper_limit, helv, 8, contentW - 8) : [];
    const blockH = 13 + reasonLines.length*11 + 11 + ulLines.length*10 + 8;
    ensureSpace(blockH);

    const niceName = labels[n.key] || n.key;
    page.drawText(winAnsi(niceName), { x: M, y, size: 11, font: helvBold, color: INK });
    page.drawText(winAnsi(n.amount), { x: M + 140, y, size: 9, font: helv, color: INK_SOFT });
    const lvl = n.level === 'hoch' ? 3 : n.level === 'moderat' ? 2 : 1;
    for (let i = 0; i < 3; i++) {
      page.drawRectangle({
        x: W - M - 30 + i*8, y: y + 1, width: 5, height: 8,
        color: i < lvl ? BRAND : LINE
      });
    }
    y -= 13;
    for (const ln of reasonLines) {
      page.drawText(ln, { x: M + 8, y, size: 9, font: helv, color: INK_SOFT });
      y -= 11;
    }
    page.drawText(winAnsi('Quellen: ' + n.food_sources.join(', ')), {
      x: M + 8, y, size: 8, font: helv, color: INK_SOFT
    });
    y -= 11;
    for (const ln of ulLines) {
      page.drawText(ln, { x: M + 8, y, size: 8, font: helv, color: WARN });
      y -= 10;
    }
    y -= 8;
  }

  // ─── modifiers ─────────────────────────────────────────
  const mods = activeModifiers();
  if (mods.length) {
    ensureSpace(20);
    y -= 4;
    page.drawText('Besonderheiten', { x: M, y, size: 11, font: helvBold, color: BRAND });
    y -= 16;
    for (const m of mods) {
      const noteLines = m.note ? wrap(m.note, helv, 8, contentW - 8) : [];
      const adjLines = [];
      if (m.adjust) {
        for (const [k, v] of Object.entries(m.adjust)) {
          for (const ln of wrap((labels[k] || k) + ': ' + v, helv, 8, contentW - 8)) {
            adjLines.push(ln);
          }
        }
      }
      const modH = 12 + noteLines.length*10 + adjLines.length*10 + 6;
      ensureSpace(modH);

      page.drawRectangle({ x: M, y: y - 4, width: 3, height: 14, color: BRAND_SOFT });
      page.drawText(winAnsi(m.label), { x: M + 8, y, size: 10, font: helvBold, color: INK });
      y -= 12;
      for (const ln of noteLines) {
        page.drawText(ln, { x: M + 8, y, size: 8, font: helv, color: INK_SOFT });
        y -= 10;
      }
      for (const ln of adjLines) {
        page.drawText(ln, { x: M + 8, y, size: 8, font: helv, color: INK });
        y -= 10;
      }
      y -= 6;
    }
  }

  // ─── comment (conditional) ─────────────────────────────
  const c = (state.kommentar || '').trim();
  if (c) {
    const commentLines = wrap(c, helvOblique, 10, contentW);
    ensureSpace(10 + 14 + 14 + commentLines.length*13 + 6);
    y -= 10;
    page.drawLine({ start:{x:M,y}, end:{x:W-M,y}, color: BRAND_SOFT, thickness: 0.8 });
    y -= 14;
    page.drawText('PERSÖNLICHE ANMERKUNG', { x: M, y, size: 8, font: helvBold, color: BRAND_SOFT });
    y -= 14;
    for (const ln of commentLines) {
      page.drawText(ln, { x: M, y, size: 10, font: helvOblique, color: INK });
      y -= 13;
    }
    y -= 6;
  }

  // ─── ActiNovo box (compact, clickable) ─────────────────
  const url = buildTrackedUrl();
  const abH = 60;
  ensureSpace(abH + 16);
  y -= 6;
  page.drawRectangle({ x: M, y: y - abH, width: contentW, height: abH, color: TINT });
  page.drawText('Bezugsquelle ActiNovo', { x: M + 12, y: y - 16, size: 10, font: helvBold, color: BRAND });
  page.drawText('Empfehlungs-Code:  ' + DISCOUNT_CODE + '   ·   15 % auf die Erstbestellung', {
    x: M + 12, y: y - 32, size: 9, font: helv, color: INK
  });
  page.drawText('QR scannen oder Code auf actinovo.com einlösen', {
    x: M + 12, y: y - 46, size: 8, font: helvOblique, color: INK_SOFT
  });
  try {
    const qrDataUrl = makeQrDataUrl(url, 240);
    const qrBytes = await fetch(qrDataUrl).then(r => r.arrayBuffer());
    const qrImg = await doc.embedPng(qrBytes);
    const qrSize = 50;
    const qrX = W - M - qrSize - 8;
    const qrY = y - abH + 5;
    page.drawImage(qrImg, { x: qrX, y: qrY, width: qrSize, height: qrSize });
    addLinkAnnot(qrX, qrY, qrSize, qrSize, url);
  } catch(e) {
    console.error('QR PDF:', e);
    const qrSize = 50;
    const qrX = W - M - qrSize - 8;
    const qrY = y - abH + 5;
    page.drawRectangle({
      x: qrX, y: qrY, width: qrSize, height: qrSize,
      borderColor: WARN, borderWidth: 0.6
    });
    page.drawText('QR-Fehler', { x: qrX + 4, y: qrY + qrSize/2 - 3, size: 7, font: helv, color: WARN });
  }
  addLinkAnnot(M, y - abH, contentW, abH, url);
  y -= abH + 12;

  // ─── sources block (flows with content) ────────────────
  const sourceText = 'Quellen: ' + DATA.sources.map(s => s.label).join(' · ');
  const sourceLines = wrap(sourceText, helv, 8, contentW);
  ensureSpace(14 + sourceLines.length*10);
  page.drawLine({ start:{x:M,y}, end:{x:W-M,y}, color: LINE, thickness: 0.4 });
  y -= 12;
  for (const ln of sourceLines) {
    page.drawText(ln, { x: M, y, size: 8, font: helv, color: INK_SOFT });
    y -= 10;
  }

  // ─── per-page bottom bar: Seite N / M · actinovo.com ───
  const acto = 'actinovo.com';
  const actW = helv.widthOfTextAtSize(acto, 8);
  const total = pages.length;
  for (let i = 0; i < total; i++) {
    const p = pages[i];
    const metaBase = (who || 'Erstellt mit dem ActiNovo Hebammen-Tool')
      + (to ? ' · für ' + to : '') + ' · ' + when;
    const left = (total > 1)
      ? 'Seite ' + (i + 1) + ' / ' + total + ' · ' + metaBase
      : metaBase;
    p.drawText(winAnsi(left), { x: M, y: M - 14, size: 8, font: helv, color: INK_SOFT });
    p.drawText(acto, { x: W - M - actW, y: M - 14, size: 8, font: helv, color: BRAND });
    addLinkAnnot(W - M - actW, M - 16, actW, 10, url, p);
  }

  return await doc.save();
}

// ─── HTML export (standalone, mobile-friendly) ─────────────────────
async function buildHtml() {
  const { who, to, when } = metaParts();
  const labels = DATA.nutrient_labels || {};
  const url = buildTrackedUrl();
  let qrDataUrl;
  try {
    qrDataUrl = await makeQrDataUrl(url, 280);
  } catch(e) {
    console.error('QR HTML:', e);
    qrDataUrl = ''; // graceful: HTML still renders with text-only CTA
  }

  const nutrientsHtml = effectiveNutrients().map(n => {
    const lvl = n.level === 'hoch' ? 3 : n.level === 'moderat' ? 2 : 1;
    const bars = Array.from({length: 3}, (_, i) =>
      `<span style="width:6px;height:10px;display:inline-block;background:${i<lvl?'#003087':'#E3E7EE'};margin-right:2px;border-radius:1px;"></span>`).join('');
    const ul = n.upper_limit
      ? `<div style="color:#C97817;font-size:11px;margin-top:3px;">⚠ Obergrenze: ${escapeHtml(n.upper_limit)}</div>` : '';
    return `<tr>
      <td style="padding:10px 0;border-bottom:1px dashed #E3E7EE;vertical-align:top;">
        <div style="font-weight:600;color:#1A1A1A;">${escapeHtml(labels[n.key] || n.key)}</div>
        <div style="color:#5A6173;font-size:13px;margin-top:1px;">${escapeHtml(n.amount)}</div>
        <div style="color:#5A6173;font-size:13px;margin-top:4px;">${escapeHtml(n.reason)}</div>
        <div style="color:#5A6173;font-size:11px;margin-top:2px;">Quellen: ${escapeHtml(n.food_sources.join(', '))}</div>
        ${ul}
      </td>
      <td style="padding:10px 0;border-bottom:1px dashed #E3E7EE;vertical-align:top;text-align:right;white-space:nowrap;">${bars}</td>
    </tr>`;
  }).join('');

  const mods = activeModifiers();
  const modsHtml = mods.length ? `
    <h3 style="font-size:13px;color:#003087;text-transform:uppercase;letter-spacing:.06em;margin:24px 0 8px;">Besonderheiten</h3>
    ${mods.map(m => {
      const adjs = m.adjust
        ? Object.entries(m.adjust).map(([k, v]) =>
            `<div style="font-size:12px;margin-top:3px;"><strong>${escapeHtml(labels[k] || k)}:</strong> ${escapeHtml(v)}</div>`).join('')
        : '';
      return `<div style="background:#FFF8EE;border-left:3px solid #C97817;padding:10px 14px;border-radius:4px;margin-bottom:10px;font-size:13px;">
        <strong>${escapeHtml(m.label)}.</strong> ${escapeHtml(m.note || '')}
        ${adjs}
      </div>`;
    }).join('')}` : '';

  const c = (state.kommentar || '').trim();
  const commentHtml = c ? `
    <div style="margin-top:18px;background:#fff;border:1px solid #005AB9;padding:12px 16px;border-radius:8px;">
      <div style="font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#005AB9;font-weight:600;margin-bottom:4px;">Persönliche Anmerkung</div>
      <div style="font-size:14px;color:#1A1A1A;line-height:1.5;">${escapeHtml(c)}</div>
    </div>` : '';

  const personalHtml = (who || to) ? `
    <table style="width:100%;background:#EEF3FB;border-radius:8px;padding:14px;margin-bottom:20px;font-size:13px;border-collapse:separate;">
      <tr>
        <td style="padding:4px 12px;width:40px;font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#003087;font-weight:600;">Von</td>
        <td style="padding:4px 12px;font-weight:500;color:#1A1A1A;">${escapeHtml(who || '—')}</td>
        <td style="padding:4px 12px;text-align:right;color:#5A6173;font-size:11px;">${escapeHtml(when)}</td>
      </tr>
      <tr>
        <td style="padding:4px 12px;font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#003087;font-weight:600;">Für</td>
        <td style="padding:4px 12px;font-weight:500;color:#1A1A1A;" colspan="2">${escapeHtml(to || '—')}</td>
      </tr>
    </table>` : '';

  // DGE phase note (e.g. "Wochenbett=Stillzeit") is only shown in
  // the UI preview for the midwife; not in the HTML export — the
  // client gets the recommendation, not the methodology footnote.
  const phNoteHtml = '';

  const logoHtml = state.logoDataUrl
    ? `<img src="${state.logoDataUrl}" alt="Praxis-Logo" style="max-height:46px;max-width:140px;">` : '';

  const sourcesText = DATA.sources.map(s => escapeHtml(s.label)).join(' · ');

  const klientFile = slugify(to) || 'klientin';
  const docTitle = `Persönliche Nährstoff-Beratung — ${phaseLabel()}${to ? ' · ' + to : ''}`;

  return `<!DOCTYPE html>
<html lang="de">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${escapeHtml(docTitle)}</title>
<style>
  body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
         color: #1A1A1A; background: #FCFBF8; max-width: 720px;
         margin: 0 auto; padding: 28px 22px 60px; line-height: 1.5; }
  @media print { body { background: #fff; padding: 0; } .no-print { display: none; } }
  .head { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 18px; }
  .head .accent { width: 4px; align-self: stretch; min-height: 50px;
                  background: linear-gradient(180deg, #003087 0%, #005AB9 100%); border-radius: 2px; }
  .head .title-wrap { flex: 1 1 auto; }
  .head .eyebrow { font-size: 10px; letter-spacing: .12em; text-transform: uppercase;
                   color: #003087; font-weight: 600; margin-bottom: 2px; }
  .head h1 { margin: 0; font-size: 22px; font-weight: 700; letter-spacing: -.01em; line-height: 1.2; }
  .actinovo-cta { display: flex; gap: 14px; align-items: center;
                  background: #EEF3FB; padding: 14px 16px; border-radius: 10px;
                  margin-top: 18px; color: #1A1A1A; text-decoration: none; }
  .actinovo-cta:hover { background: #E3ECF8; }
  .actinovo-cta img { width: 80px; height: 80px; flex-shrink: 0; }
  .actinovo-cta .ct-text { flex: 1; font-size: 13px; line-height: 1.5; }
  .actinovo-cta strong { color: #003087; display: block; font-size: 14px; margin-bottom: 2px; }
  .actinovo-cta code { background: #fff; padding: 2px 8px; border-radius: 4px;
                       color: #003087; font-weight: 600; font-family: ui-monospace, 'SF Mono', monospace; }
  .footer { margin-top: 30px; padding-top: 14px; border-top: 1px solid #E3E7EE;
            font-size: 11px; color: #5A6173; line-height: 1.5; }
</style>
</head>
<body>
  <div class="head">
    <span class="accent"></span>
    <div class="title-wrap">
      <div class="eyebrow">Persönliche Nährstoff-Beratung</div>
      <h1>${escapeHtml(phaseLabel())}</h1>
    </div>
    ${logoHtml}
  </div>

  ${personalHtml}

  <div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:8px;gap:12px;flex-wrap:wrap;">
    <h3 style="font-size:13px;color:#003087;text-transform:uppercase;letter-spacing:.06em;margin:0;">Erhöhter Bedarf jetzt</h3>
    <div style="font-size:10px;color:#5A6173;">
      <span style="margin-right:8px;"><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span><span style="display:inline-block;width:5px;height:8px;background:#E3E7EE;"></span><span style="display:inline-block;width:5px;height:8px;background:#E3E7EE;"></span> niedrig</span>
      <span style="margin-right:8px;"><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span><span style="display:inline-block;width:5px;height:8px;background:#E3E7EE;"></span> moderat</span>
      <span><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span><span style="display:inline-block;width:5px;height:8px;background:#003087;"></span> hoch</span>
    </div>
  </div>

  ${phNoteHtml}
  <table style="width:100%;border-collapse:collapse;">${nutrientsHtml}</table>

  ${modsHtml}
  ${commentHtml}

  <a class="actinovo-cta" href="${escapeHtml(url)}" target="_blank" rel="noopener">
    ${qrDataUrl ? `<img src="${qrDataUrl}" alt="QR Code">` : ''}
    <div class="ct-text">
      <strong>Bezugsquelle ActiNovo</strong>
      Empfehlungs-Code: <code>${DISCOUNT_CODE}</code> · 15 % auf die Erstbestellung.<br>
      <span style="color:#5A6173;font-size:11px;">${qrDataUrl ? 'QR scannen oder antippen — Code wird automatisch eingelöst.' : 'Antippen — Code wird automatisch eingelöst.'}</span>
    </div>
  </a>

  <div class="footer">
    Quellen: ${sourcesText}<br>
    <em>${escapeHtml((who || 'Erstellt mit dem ActiNovo Hebammen-Tool') + (to ? ' · für ' + to : '') + ' · ' + when)}</em>
  </div>
</body>
</html>`;
}

// ─── wire up ───────────────────────────────────────────────────────
const $ = id => document.getElementById(id);

$('hebName').oninput = (e) => { state.hebName = e.target.value; renderPreview(); };
$('hebStadt').oninput = (e) => { state.hebStadt = e.target.value; renderPreview(); };
$('klientin').oninput = (e) => { state.klientin = e.target.value; renderPreview(); };
$('kommentar').oninput = (e) => { state.kommentar = e.target.value; renderPreview(); };

$('hebLogo').onchange = (e) => {
  const f = e.target.files[0];
  if (!f) { state.logoDataUrl = null; renderPreview(); return; }
  if (f.size > 1024*1024) {
    $('statusMsg').textContent = 'Logo zu groß (max 1 MB).';
    $('statusMsg').className = 'status warn';
    return;
  }
  const reader = new FileReader();
  reader.onload = () => { state.logoDataUrl = reader.result; renderPreview(); };
  reader.readAsDataURL(f);
};

function downloadBlob(bytes, mime, filename) {
  const blob = new Blob([bytes], { type: mime });
  const u = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = u; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(u);
}

function pickFilename(ext) {
  const klient = slugify(state.klientin) || 'klientin';
  return 'beratungsblatt-' + (state.phase || 'phase') + '-' + klient + '.' + ext;
}


/* ── Messung ───────────────────────────────────────────────────────────────
   Ohne diese Ereignisse ist im GA4 nur der Seitenaufruf sichtbar, nicht ob
   das Tool ueberhaupt benutzt wird. Bewusst ohne personenbezogene Daten:
   nur Phase und Anzahl der Besonderheiten, keine Klientinnen-Angaben.
   gtag existiert erst nach Einwilligung — beide Aufrufe sind daher abgesichert. */
function anTrack(name, props) {
  try {
    var payload = Object.assign({ tool: 'hebammen-beratungsblatt' }, props || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
  } catch (e) {}
}
var anStarted = false;
function anStart() {
  if (anStarted) return;
  anStarted = true;
  anTrack('an_tool_start');
}
document.addEventListener('change', anStart, { once: false, passive: true });
document.addEventListener('click', function (e) {
  if (e.target && e.target.closest && e.target.closest('.pill, .chip, button')) anStart();
}, { passive: true });

$('downloadPdfBtn').onclick = async () => {
  const btn = $('downloadPdfBtn'); const status = $('statusMsg');
  btn.disabled = true; status.textContent = 'PDF wird erzeugt …'; status.className = 'status';
  try {
    const bytes = await buildPdf();
    downloadBlob(bytes, 'application/pdf', pickFilename('pdf'));
    anTrack('an_tool_output', { format: 'pdf', phase: state.phase || '', modifiers: state.modifiers.size, personalisiert: !!state.hebName });
    status.textContent = 'PDF heruntergeladen.'; status.className = 'status ok';
  } catch (e) {
    console.error(e);
    status.textContent = 'Fehler beim Erzeugen: ' + e.message; status.className = 'status warn';
  } finally { btn.disabled = false; }
};

$('downloadHtmlBtn').onclick = async () => {
  const btn = $('downloadHtmlBtn'); const status = $('statusMsg');
  btn.disabled = true; status.textContent = 'HTML wird erzeugt …'; status.className = 'status';
  try {
    const html = await buildHtml();
    downloadBlob(html, 'text/html;charset=utf-8', pickFilename('html'));
    anTrack('an_tool_output', { format: 'html', phase: state.phase || '', modifiers: state.modifiers.size, personalisiert: !!state.hebName });
    status.textContent = 'HTML heruntergeladen.'; status.className = 'status ok';
  } catch (e) {
    console.error(e);
    status.textContent = 'Fehler beim Erzeugen: ' + e.message; status.className = 'status warn';
  } finally { btn.disabled = false; }
};

// Web Share API: only show on mobile / supported browsers
if (navigator.share && navigator.canShare) {
  $('shareBtn').style.display = '';
  $('shareBtn').onclick = async () => {
    const status = $('statusMsg');
    try {
      const bytes = await buildPdf();
      const file = new File([bytes], pickFilename('pdf'), { type: 'application/pdf' });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Persönliche Nährstoff-Beratung',
          text: 'Persönliches Beratungsblatt' + (state.klientin ? ' für ' + state.klientin : '')
        });
        anTrack('an_tool_output', { format: 'share', phase: state.phase || '', modifiers: state.modifiers.size, personalisiert: !!state.hebName });
        status.textContent = 'Geteilt.'; status.className = 'status ok';
      } else {
        // fallback to download
        downloadBlob(bytes, 'application/pdf', pickFilename('pdf'));
      }
    } catch (e) {
      if (e.name !== 'AbortError') {
        status.textContent = 'Teilen fehlgeschlagen: ' + e.message; status.className = 'status warn';
      }
    }
  };
}

$('resetBtn').onclick = () => {
  state.phase = null; state.modifiers.clear();
  state.hebName = ''; state.hebStadt = ''; state.klientin = ''; state.kommentar = '';
  state.logoDataUrl = null;
  $('hebName').value = ''; $('hebStadt').value = ''; $('klientin').value = '';
  $('kommentar').value = ''; $('hebLogo').value = '';
  $('statusMsg').textContent = ''; $('statusMsg').className = 'status';
  renderPhasePills(); renderModifierChips(); renderPreview();
};

// ─── init ──────────────────────────────────────────────────────────
(async () => {
  await loadData();
  if (!DATA) return;
  renderPhasePills();
  renderModifierChips();
  renderPreview();
})();